export function isStaleChunkLoadError(error: unknown): boolean {
  const message = extractErrorText(error).toLowerCase();

  return [
    'failed to fetch dynamically imported module',
    'importing a module script failed',
    'loading chunk',
    'chunkloaderror',
    'error loading dynamically imported module',
  ].some((pattern) => message.includes(pattern));
}

export async function refreshApplicationAfterUpdate(): Promise<void> {
  try {
    if ('caches' in window) {
      const cacheNames = await window.caches.keys();
      await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
    }
  } catch (error) {
    console.warn('[app-refresh] cache cleanup failed', error);
  }

  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch (error) {
    console.warn('[app-refresh] service worker cleanup failed', error);
  }

  window.location.reload();
}

export function showAppUpdatedBanner(): void {
  if (typeof document === 'undefined' || document.getElementById('prowycena-update-banner')) {
    return;
  }

  const banner = document.createElement('div');
  banner.id = 'prowycena-update-banner';
  banner.setAttribute('role', 'alert');
  banner.style.cssText = [
    'position:fixed',
    'left:12px',
    'right:12px',
    'bottom:12px',
    'z-index:2147483647',
    'display:flex',
    'gap:12px',
    'align-items:center',
    'justify-content:space-between',
    'padding:14px',
    'border-radius:16px',
    'background:#0f1217',
    'border:1px solid #f59e0b',
    'color:#fff',
    'box-shadow:0 20px 50px rgba(0,0,0,.45)',
    'font-family:system-ui,sans-serif',
  ].join(';');

  const message = document.createElement('div');
  message.textContent = 'Aplikacja zosta\u0142a zaktualizowana. Od\u015bwie\u017c, aby pobra\u0107 now\u0105 wersj\u0119.';
  message.style.cssText = 'font-size:14px;font-weight:700;line-height:1.35';

  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = 'Od\u015bwie\u017c aplikacj\u0119';
  button.style.cssText = [
    'min-height:44px',
    'padding:0 14px',
    'border-radius:12px',
    'border:0',
    'background:#00e676',
    'color:#000',
    'font-weight:900',
    'white-space:nowrap',
  ].join(';');

  button.addEventListener('click', () => {
    void refreshApplicationAfterUpdate();
  });

  banner.append(message, button);
  document.body.appendChild(banner);
}

function extractErrorText(error: unknown): string {
  if (error instanceof Error) return `${error.name} ${error.message} ${error.stack ?? ''}`;
  if (typeof error === 'string') return error;

  if (error && typeof error === 'object') {
    const maybeMessage =
      (error as { message?: unknown; reason?: unknown }).message ??
      (error as { reason?: unknown }).reason;

    return typeof maybeMessage === 'string' ? maybeMessage : JSON.stringify(error);
  }

  return String(error);
}
